import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-share-social-media-modal',
  templateUrl: './share-social-media-modal.component.html',
  styleUrls: ['./share-social-media-modal.component.scss']
})
export class ShareSocialMediaModalComponent {
    articleSlug: string;
    articleTitle: string;
    page: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
      this.articleSlug = data.articleSlug;
      this.articleTitle = data.articleTitle;
      this.page = data.page;
    }
  // link for creating social share : https://dev.to/rodrigokamada/adding-the-social-media-share-buttons-component-to-an-angular-application-320h
}